module.exports = __webpack_public_path__ + "static/media/appstore.ac097724.png";